"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArrowDimensions = void 0;
function getArrowDimensions(arrowShape, width, height, numberOfArrowHeads) {
    const arrowTailWidth = (arrowShape.tailWidth / 100) * height;
    const headWidth = (arrowShape.headWidth / 100) * width;
    const arrowHeadLength = numberOfArrowHeads === 2 ? headWidth / 2 : headWidth;
    return { arrowTailWidth, arrowHeadLength };
}
exports.getArrowDimensions = getArrowDimensions;
//# sourceMappingURL=utility.arrow.js.map